<template>
	<div>
		<span>
			<b-button v-on:click="edit()" size="sm" variant="outline-light">
				<Icon icon="material-symbols:edit" width="20" height="20" v-b-tooltip.hover.bottom="$t('Edit')" color="#7367F0" />
			</b-button>
		</span>
		<span>
			<b-button v-on:click="deleteData()" size="sm" variant="outline-light">
				<Icon icon="ic:baseline-remove-circle" width="20" height="20" v-b-tooltip.hover.bottom="$t('Delete')"
					color="#ea5455" />
			</b-button>
		</span>
	</div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
	props: ["editMethod", "deleteMethod"],
	components: { Icon },
	methods: {
		edit() { this.$root.$emit(this.params.editMethod, this.params.data); },
		deleteData() { this.$root.$emit(this.params.deleteMethod, this.params.data); },
	}
}
</script>